import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TeacherDetailScreenPath } from "./TeacherDetailScreen.tsx";

export function useToTeacherDetail() {
  const navigate = useNavigate();
  const toTeacherDetail = useCallback(
    (teacherId: string) => {
      navigate(TeacherDetailScreenPath.replace(":teacherId", teacherId));
    },
    [navigate],
  );

  return { toTeacherDetail };
}
